(function () {
    'use strict';

    angular
        .module('app')
        .directive('menuDropdown', menuDropdown);

    menuDropdown.$inject = [];

    function menuDropdown() {
        return {
            restrict: 'E',
            transclude: {
                'toggle': 'menuDropdownToggle',
                'pane': 'menuDropdownPane'
            },
            templateUrl: 'app/common/directives/dropdown/dropdown.view.html',
            controller: 'DropdownController',
            controllerAs: 'vm',
            scope: {
                active: '=?isOpen'
            },
            bindToController: true
        };
    }
})();